"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = require("../info-auth-api/api");
var jwt = require("jsonwebtoken");
var aws_token_validator_1 = require("../utils/aws.token.validator");
var constants_1 = require("../constants");
// eslint-disable-next-line
var OktaAuth = require('@okta/okta-auth-js');
var InfoAuth = /** @class */ (function () {
    function InfoAuth() {
        // No Op
    }
    InfoAuth.prototype.setConfig = function (coreConfig) {
        this.coreConfig = coreConfig;
    };
    InfoAuth.prototype.getConfig = function () {
        return this.coreConfig;
    };
    InfoAuth.prototype.setAuthProvider = function (authProvider) {
        this.authProvider = authProvider;
    };
    InfoAuth.prototype.setInfoAuthProvider = function (infoAuthProvider) {
        this.infoAuthProvider = infoAuthProvider;
    };
    Object.defineProperty(InfoAuth, "INSTANCE", {
        get: function () {
            if (InfoAuth.authInstance === undefined) {
                InfoAuth.authInstance = new InfoAuth();
            }
            return InfoAuth.authInstance;
        },
        enumerable: false,
        configurable: true
    });
    InfoAuth.prototype.isConfigured = function () {
        return this.authProvider !== undefined;
    };
    /**
     * Get current authenticated user
     * @param params
     */
    InfoAuth.prototype.currentAuthenticatedUser = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAuthProvider().currentAuthenticatedUser(params)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Log In
     * @param username
     * @param password
     */
    InfoAuth.prototype.signIn = function (username, password, locale) {
        return __awaiter(this, void 0, void 0, function () {
            var authUser, currentSession, authToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAuthProvider().signIn(username, password, locale)];
                    case 1:
                        authUser = _a.sent();
                        return [4 /*yield*/, this.currentSession()];
                    case 2:
                        currentSession = _a.sent();
                        authToken = currentSession.accessToken.token;
                        if (!this.coreConfig.activityTracking.isRequired) return [3 /*break*/, 4];
                        return [4 /*yield*/, createActivityTracking('Login', authToken, this.coreConfig)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, authUser];
                }
            });
        });
    };
    /**
     * logout
     */
    InfoAuth.prototype.signOut = function () {
        return __awaiter(this, void 0, void 0, function () {
            var currentSession, e_1, authToken, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 4]);
                        return [4 /*yield*/, this.currentSession()];
                    case 1:
                        currentSession = _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        e_1 = _a.sent();
                        return [4 /*yield*/, this.getAuthProvider().signOut()];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        authToken = currentSession.accessToken.token;
                        return [4 /*yield*/, this.getAuthProvider().signOut()];
                    case 5:
                        result = _a.sent();
                        if (!this.coreConfig.activityTracking.isRequired) return [3 /*break*/, 7];
                        return [4 /*yield*/, createActivityTracking('Logout', authToken, this.coreConfig)];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7: return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * Sign up with username, password and other attributes like phone, email
     * @param params
     */
    InfoAuth.prototype.signUp = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAuthProvider().signUp(params)];
                    case 1:
                        res = _a.sent();
                        if (!this.infoAuthProvider) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.infoAuthProvider.signUpUserProfile(params, res)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, res];
                }
            });
        });
    };
    /**
     * Send the verfication code to confirm sign up
     * @param username
     * @param code
     */
    InfoAuth.prototype.confirmSignUp = function (username, code, transactionId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAuthProvider().confirmSignUp(username, code, transactionId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Send username to insert default usermapping
     * @param username
     */
    InfoAuth.prototype.insertDefaultUserMapping = function (userId, transactionId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.infoAuthProvider) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.infoAuthProvider.insertDefaultUserMapping(userId, transactionId)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, 'FAILURE'];
                }
            });
        });
    };
    /**
     * Request to resend the verification code
     * @param username
     */
    InfoAuth.prototype.resendSignUp = function (username) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAuthProvider().resendSignUp(username)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Change password by authenticated user
     * @param user
     * @param oldPassword
     * @param newPassword
     */
    InfoAuth.prototype.changePassword = function (user, oldPassword, newPassword) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAuthProvider().changePassword(user, oldPassword, newPassword)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Initiate a forgot password request
     * @param username
     */
    InfoAuth.prototype.forgotPassword = function (username) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAuthProvider().forgotPassword(username)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Confirm a new password using a confirmation Code
     * @param username
     * @param code
     * @param password
     */
    InfoAuth.prototype.forgotPasswordSubmit = function (username, code, password) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAuthProvider().forgotPasswordSubmit(username, code, password)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get current user's session
     */
    InfoAuth.prototype.currentSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAuthProvider().currentSession()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     *
     * @param user Update user attributes
     * @param attributes
     */
    InfoAuth.prototype.updateUserAttributes = function (user, attributes) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, 'SUCCESS'];
            });
        });
    };
    InfoAuth.prototype.getAuthProvider = function () {
        if (this.authProvider !== undefined) {
            return this.authProvider;
        }
        throw new Error('Configuration is not done ');
    };
    return InfoAuth;
}());
exports.default = InfoAuth;
var createActivityTracking = function (userActivity, token, coreConfig) { return __awaiter(void 0, void 0, void 0, function () {
    var userData, _a, authClient, userDataMap, activityTrackingData, res;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                userData = {};
                _a = coreConfig.provider.type.default;
                switch (_a) {
                    case 'aws': return [3 /*break*/, 1];
                    case 'infoauth': return [3 /*break*/, 3];
                    case 'okta': return [3 /*break*/, 4];
                }
                return [3 /*break*/, 5];
            case 1: return [4 /*yield*/, aws_token_validator_1.tokenHandler(token, coreConfig.provider.aws)];
            case 2:
                userData = _b.sent();
                return [3 /*break*/, 6];
            case 3:
                userData = jwt.verify(token, constants_1.SECRET_KEY);
                return [3 /*break*/, 6];
            case 4:
                authClient = new OktaAuth({
                    issuer: coreConfig.provider.okta.issuer,
                });
                userData = authClient.token.decode(token);
                userData = userData['payload'];
                return [3 /*break*/, 6];
            case 5: throw new Error('Invalid Auth Provider');
            case 6:
                userDataMap = new Map(Object.entries(userData));
                activityTrackingData = { userActivityTarget: userActivity, userActivityType: userActivity, projectId: 0, applicationId: 0, userAction: userActivity, timestamp: new Date(), createdByUserId: userDataMap.get('sub'), createdByUserName: userDataMap.get('sub') };
                return [4 /*yield*/, api_1.default.createActivityTracking(coreConfig.activityTracking.url, activityTrackingData, token, coreConfig.provider.type.default)];
            case 7:
                res = _b.sent();
                return [2 /*return*/];
        }
    });
}); };
//# sourceMappingURL=info.auth.js.map